/**  @jsx jsx */

import { Button, Margin, Surface, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import { BASE_APP_URL } from 'app/developer-v3/constants';

const Styles = {
  container: css`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 30px;
    justify-content: center;
  `,
};

type Props = {
  /** URL to link the user back */
  escapeRoute?: string;
  /** Type of item */
  noun: 'trigger' | 'action' | 'item';
  /** Key of the nout found item */
  unknownKey: string;
};

/**
 * Renders a not found Surface block with the name of the provided noun
 *
 * Used for Actions and Triggers
 * @param Props
 * @returns JSX.Element
 */
const NotFound = ({ unknownKey, escapeRoute, noun }: Props) => (
  <Margin margin="40px">
    <Surface borderColor="GrayWarm4">
      <div css={Styles.container}>
        <Text margin="0px 0px 20px 0px" textAlign="center" type="SectionHeader">
          Not Found
        </Text>
        <Text margin="0px 0px 20px" textAlign="center">
          <code>{unknownKey}</code> isn't a known {noun}
        </Text>
        {escapeRoute && (
          <Button href={escapeRoute} iconBefore="arrowBigLeft">
            Head back
          </Button>
        )}
      </div>
    </Surface>
  </Margin>
);

NotFound.defaultProps = {
  escapeRoute: `${BASE_APP_URL}/`,
};

export default NotFound;
